export const FORCE_RENDER_ON_DESIGN_CHANGE_OPTIONS = {
  FIRST: 'first',
  LAST: 'last',
  DEFAULT: ''
};

export const MOBILE_HOTSPOTS_VIEWS = {
  ALL_HOTSPOTS: 1,
  SWAPPING_HOTSPOTS_ONLY: 2,
  ALL_HOTSPOTS_WITH_SWAP_STYLING: 3
};
